import { useState, useEffect } from 'react';
import calcResolutionType from 'functions/calcResolutionType';

const useResolutionType = () => {
  const [resolutionType, setResolutionType] = useState(calcResolutionType());

  useEffect(() => {
    const resizeHandler = () => {
      setResolutionType(calcResolutionType());
    };

    window.addEventListener('resize', resizeHandler, { passive: false });

    return () => window.removeEventListener('resize', resizeHandler, { passive: false });
  }, []);

  return resolutionType;
};

export default useResolutionType;
